import storage from '@/store/localstorage.js'

const state = {
  id: storage.get('userId') || '',
  user_name: storage.get('userName') || '',
  email: storage.get('userEmail') || '',
  user_privilege: storage.get('userPrivilege') || '',
  privilege_id: storage.get('userPrivilegeId') || 0,
  birthday: storage.get('birthday') || '',
  gender: storage.get('gender') || 0
}

const getters = {
  id: (state) => {
    return state.id
  },
  data: (state) => {
    return state
  },
  isLogged: (state) => {
    return !!state.id
  },
  isAdmin: (state) => {
    return Number(state.privilege_id) === 1 // 1管理者、2一般ユーザ
  }
}

const mutations = {
  LOGGED_IN (state, data) {
    console.log(data)
    state.id = data.id
    state.user_name = data.user_name
    state.email = data.email
    state.user_privilege = data.user_privilege
    state.privilege_id = data.privilege_id
    state.birthday = data.birthday
    state.gender = data.gender
    storage.set('userId', state.id)
    storage.set('userName', state.user_name)
    storage.set('userEmail', state.email)
    storage.set('userPrivilege', state.user_privilege)
    storage.set('userPrivilegeId', state.privilege_id)
    storage.set('birthday', state.birthday)
    storage.set('gender', state.gender)
  },
  LOGGED_OUT (state) {
    storage.remove('userId')
    storage.remove('userName')
    storage.remove('userEmail')
    storage.remove('userPrivilege')
    storage.remove('userPrivilegeId')
    storage.remove('birthday')
    storage.remove('gender')
    state.id = ''
    state.user_name = ''
    state.email = ''
    state.user_privilege = ''
    state.privilege_id = 0
    state.birthday = ''
    state.gender = 0
  },
  UPDATE (state, data) {
    state.user_name = data.user_name
    state.birthday = data.birthday
    state.gender = data.gender
    storage.set('userName', state.user_name)
    storage.set('birthday', state.birthday)
    storage.set('gender', state.gender)
  }
}

const actions = {
  loggedin ({ commit }, payload) {
    return commit('LOGGED_IN', payload)
  },
  logout ({ commit }) {
    return commit('LOGGED_OUT')
  },
  update ({ commit }, payload) {
    return commit('UPDATE', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
